(function(config) {
    'use strict';

    angular.module('user.services', [
            'ngResource'
        ])
        .factory('userAuthDataService', userAuthDataService)
        .factory('userAuthService', userAuthService)
        .factory('userStorageSrvc', userStorageSrvc)
        .factory('tokenInterceptor', tokenInterceptor)
        .factory('checkPermissionsSrvc', checkPermissionsSrvc)
        .factory('checkModelPermissionsSrvc', checkModelPermissionsSrvc)
        .factory('adminDataSrvc', adminDataSrvc)
        .factory('adminSrvc', adminSrvc)
        .factory('clientDataSrvc', clientDataSrvc)
        .factory('clientSrvc', clientSrvc)
        .factory('allowedIpDataSrvc', allowedIpDataSrvc)
        .factory('allowedIpSrvc', allowedIpSrvc)
        .factory('modelPermissionsGroupDataSrvc', modelPermissionsGroupDataSrvc)
        .factory('modelPermissionsGroupSrvc', modelPermissionsGroupSrvc)
        .factory('modelPermissionsDataSrvc', modelPermissionsDataSrvc)
        .factory('discountGroupDataSrvc', discountGroupDataSrvc);

    userAuthDataService.$inject = ['$resource'];

    function userAuthDataService($resource) {
        return $resource('', {}, {
            tokenAuth: {
                method: 'POST',
                url: config.api + '/api/token-auth/'
            }
        });
    }

    userAuthService.$inject = ['$q', '$state', 'userRedirectConst', 'userAuthDataService', 'userStorageSrvc', 'adminDataSrvc'];

    function userAuthService($q, $state, userRedirectConst, userAuthDataService, userStorageSrvc, adminDataSrvc) {

        return {
            login: login,
            logout: logout
        };

        function getUserPk(username, errors) {
            return adminDataSrvc.getAdminByUsername({
                "username": username
            }).$promise.then(function(result) {
                userStorageSrvc.setUser(result.user);
                sessionStorage.setItem('showUnsentInvoicesModal', '1');
                $state.go(userRedirectConst.afterLogin);
                return result;
            });
        }

        function login(credentials, errors) {
            return userAuthDataService.tokenAuth(
                credentials
            ).$promise.then(function(result) {
                userStorageSrvc.setToken(result.token);
                return getUserPk(credentials.username, errors);
            }).catch(function(reason) {
                errors.username = reason.data.username;
                errors.password = reason.data.password;
                errors.nonFieldErrors = [];

                if (reason.data.detail) {
                    errors.nonFieldErrors.push(reason.data.detail);
                }

                if (reason.data.non_field_errors) {
                    errors.nonFieldErrors.push.apply(
                        errors.nonFieldErrors, reason.data.non_field_errors);
                }

                return $q.reject(reason);
            });
        }

        function logout(resolve, reject) {
            return $q(function(resolve, reject) {
                userStorageSrvc.removeToken();
                $state.go(userRedirectConst.afterLogout);
            });
        }
    }

    userStorageSrvc.$inject = ['localStorageService'];

    function userStorageSrvc(localStorageService) {

        var tokenKey = "caffeprint.user.token";
        var adminObj = "caffeprint.userObj";

        return {
            getUser: getUser,
            setUser: setUser,
            removeUser: removeUser,
            getToken: getToken,
            setToken: setToken,
            isToken: isToken,
            removeToken: removeToken
        };

        function getUser() {
            return localStorageService.get(adminObj);
        }

        function setUser(user) {
            localStorageService.set(adminObj, user);
        }

        function removeUser() {
            localStorageService.remove(adminObj);
        }

        function getToken() {
            return localStorageService.get(tokenKey);
        }

        function setToken(token) {
            localStorageService.set(tokenKey, token);
        }

        function isToken() {
            return !!localStorageService.get(tokenKey);
        }

        function removeToken() {
            localStorageService.remove(tokenKey);
        }
    }

    tokenInterceptor.$inject = ['$q', '$injector', 'userStorageSrvc', 'userRedirectConst', 'notificationSrvc'];

    function tokenInterceptor($q, $injector, userStorageSrvc, userRedirectConst, notificationSrvc) {
        return {
            request: function(config) {
                if (userStorageSrvc.isToken()) {
                    config.headers.Authorization = 'Token ' + userStorageSrvc.getToken();
                }

                return config;
            },
            responseError: function(response) {
                if (response.status === 401) {
                    var deferred = $q.defer();

                    if (userStorageSrvc.isToken()) {
                        userStorageSrvc.removeToken();
                        userStorageSrvc.removeUser();
                    }

                    notificationSrvc.notification("success", response.data.detail);

                    var $state = $injector.get('$state');
                    var currentStateName = $state.current.name;

                    if (currentStateName !== 'login.username' &&
                        currentStateName !== 'login.barcode') {
                        $state.go(userRedirectConst.onTokenResponseError);
                    }

                    return deferred.promise;
                }

                return $q.reject(response);
            }
        };
    }

    checkPermissionsSrvc.$inject = ['$state', 'userPermissionsConst', 'userStorageSrvc', 'userRedirectConst'];

    function checkPermissionsSrvc($state, userPermissionsConst, userStorageSrvc, userRedirectConst) {
        return {
            check: function(event, toState, toParams, fromState, fromParams) {
                if (toState.data && toState.data.permission) {
                    if (userStorageSrvc.isToken() && toState.data.permission === userPermissionsConst.anonymous) {
                        event.preventDefault();

                        if (fromState.name) {
                            $state.go(fromState.name, fromParams);
                        } else {
                            $state.go(userRedirectConst.ifUser);
                        }
                    } else if (!userStorageSrvc.isToken() && toState.data.permission === userPermissionsConst.user) {
                        event.preventDefault();

                        if (fromState.name) {
                            $state.go(fromState.name, fromParams);
                        } else {
                            $state.go(userRedirectConst.ifAnonymous);
                        }
                    }
                }
            }
        };
    }

    checkModelPermissionsSrvc.$inject = ['$state', 'userStorageSrvc', 'userRedirectConst', 'notificationSrvc'];

    function checkModelPermissionsSrvc($state, userStorageSrvc, userRedirectConst, notificationSrvc) {
        return {
            isDenied: isDenied,
            check: check,
            getPermittedSiteIds: getPermittedSiteIds
        };

        function isDenied(modelPermission) {
            var user = userStorageSrvc.getUser();

            if (user.is_superuser) {
                return false;
            }

            var permission = user.permissions.find(function(item) {
                return item === modelPermission.value;
            });

            return permission === undefined;
        }

        function check(event, toState, toParams, fromState, fromParams) {
            if (toState.data && toState.data.modelPermission) {
                if (isDenied(toState.data.modelPermission)) {
                    event.preventDefault();

                    notificationSrvc.notification("error", toState.data.modelPermission.errorMsg);
                    $state.go(userRedirectConst.modelPermissionReject);
                }
            }
        }

        function getPermittedSiteIds(modelPermission) {
            var user = userStorageSrvc.getUser();
            var permitedSiteIds = [];

            if (user.site_permissions !== undefined) {
                for (var id in user.site_permissions){
                    if(user.is_superuser){
                        permitedSiteIds.push(parseInt(id));

                    } else {
                        permitedSiteIds.push(user.site)
                        var permissions = user.site_permissions[id]
                        for (var i = 0; i < permissions.length; ++i) {
                            if(permissions[i].includes(modelPermission.value)){
                                permitedSiteIds.push(parseInt(id));
                            }
                        }
                    }
                }
            }
            return permitedSiteIds
        }
    }

    adminDataSrvc.$inject = ['$resource'];

    function adminDataSrvc($resource) {

        function getUsername(response) {
            angular.fromJson(response).results.map(function(obj) {
                obj.username = obj.user.username;
                return obj;
            });
            return response;
        }

        return $resource(config.api + '/api/v1/admins/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                },
                transformResponse: [angular.fromJson, getUsername]
            },
            getAdminByUsername: {
                method: 'POST',
                url: config.api + '/api/v1/admins/get_admin_by_username/'
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            barcode: {
                method: 'GET',
                url: config.api + '/api/v1/admins/:pk/barcode/'
            },
            clientContact: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/admins/client_contact_list/',
            }
        });
    }

    adminSrvc.$inject = ['adminDataSrvc', 'modalSrvc'];

    function adminSrvc(adminDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(instance, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                instance.user.username,
                function() {
                    adminDataSrvc.delete({
                        pk: instance.pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    clientDataSrvc.$inject = ['$resource'];

    function clientDataSrvc($resource) {
        return $resource(config.api + '/api/v1/clients/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            getFlattened: {
                method: 'GET',
                url: config.api + '/api/v1/clients/:pk/admin_get_flattened/'
            },
            clientContactClients: {
                method: 'GET',
                url: config.api + '/api/v1/clients/admin_client_contact_clients/',
                isArray: false
            },
            getOptions: {
                method: 'GET',
                url: config.api + '/api/v1/clients/admin_client_options/',
                isArray: false
            }
        });
    }

    clientSrvc.$inject = ['notificationSrvc', 'modalSrvc', 'clientDataSrvc', 'clientMessagesConst'];

    function clientSrvc(notificationSrvc, modalSrvc, clientDataSrvc, clientMessagesConst) {

        return {
            remove: remove,
            activate: activate
        };

        function remove(instance, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                instance.user.email,
                function() {
                    clientDataSrvc.update({
                        pk: instance.pk
                    }, {
                        user: {
                            is_active: false
                        }
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }

        function activate(instance) {
            clientDataSrvc.update({
                pk: instance.pk
            }, {
                user: {
                    is_active: true
                }
            }).$promise.then(
                function(response) {
                    instance.user.is_active = true;
                    notificationSrvc.notification("success", clientMessagesConst.activated);
                },
                function(response) {
                    notificationSrvc.notification("error", clientMessagesConst.error);
                }
            );
        }
    }

    allowedIpDataSrvc.$inject = ['$resource'];

    function allowedIpDataSrvc($resource) {
        return $resource(config.api + '/api/v1/allowed-ips/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
            },
            update: {
                method: 'PATCH',
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    allowedIpSrvc.$inject = ['allowedIpDataSrvc', 'modalSrvc'];

    function allowedIpSrvc(allowedIpDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    allowedIpDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    modelPermissionsGroupDataSrvc.$inject = ['$resource'];

    function modelPermissionsGroupDataSrvc($resource) {
        return $resource(config.api + '/api/v1/model-permissions-groups/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            adminList: {
                method: 'GET',
                url: config.api + '/api/v1/model-permissions-groups/admin_list/',
                isArray: true
            }
        });
    }

    modelPermissionsGroupSrvc.$inject = ['modelPermissionsGroupDataSrvc', 'modalSrvc'];

    function modelPermissionsGroupSrvc(modelPermissionsGroupDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    modelPermissionsGroupDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    modelPermissionsDataSrvc.$inject = ['$resource'];

    function modelPermissionsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/model-permissions/:pk/', { pk: '@pk' }, {
            modelPermissions: {
                method: 'GET',
                url: config.api + '/api/v1/model-permissions/admin_model_permissions/',
                isArray: true
            }
        });
    }

    discountGroupDataSrvc.$inject = ['$resource'];

    function discountGroupDataSrvc($resource) {
        return $resource(config.api + '/api/v1/discount-groups/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/discount-groups/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            remove: {
                method: 'DELETE'
            }
        });
    }

})(window.config);
